import { tPostConnectionsRequestBody } from "tmt_api/src/types/types.validator";

import { postConnections } from "src/util/apiNew";

import { tReduxAction } from "../types";

export const connectCustomers = (payload: tPostConnectionsRequestBody): tReduxAction => {
  return async () => {
    return postConnections(payload);
  };
};
